document.addEventListener("DOMContentLoaded", function () {
    const modal = document.getElementById("imagePreviewModal");
    const previewImg = document.getElementById("previewImage");
    const imageTitle = document.getElementById("imageTitle");

    window.previewImage = function (src, title) {
        if (previewImg && imageTitle && modal) {
            previewImg.src = src;
            imageTitle.textContent = title;
            modal.style.display = "flex"; // Fuerza la visualización del modal
            document.body.style.overflow = "hidden";
        }
    };

    window.closeImageModal = function (event) {
        if (event) event.preventDefault();
        if (modal && previewImg && imageTitle) {
            modal.style.display = "none";
            previewImg.src = "";
            imageTitle.textContent = "";
            document.body.style.overflow = "";
        }
    };

    // Cerrar modal al hacer click fuera del contenido
    if (modal) {
        modal.addEventListener("click", function (e) {
            if (e.target === modal) {
                closeImageModal();
            }
        });
    }

    // Búsqueda optimizada en la tabla
    const searchInput = document.getElementById("searchInput");
    const tableRows = document.querySelectorAll(".gestor-table tbody tr");
    if (searchInput) {
        searchInput.addEventListener("input", function () {
            const value = this.value.trim().toLowerCase();
            tableRows.forEach((row) => {
                const titleCell = row.querySelector("td h6");
                if (titleCell) {
                    row.style.display = titleCell.textContent
                        .toLowerCase()
                        .includes(value)
                        ? ""
                        : "none";
                }
            });
        });
    }
});
